import _ from 'lodash';

export const getIsButtonEnabled = (count, initialGlucoseStripCount, errors) => {
  if (_.isEqual(count, initialGlucoseStripCount) || Object.values(errors).some((e) => e)) {
    return false;
  }

  return true;
};
